import React, { useState, useEffect } from "react";
import "./AnalyticsGraphs.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Brush,
} from "recharts";

const AnalyticsGraphs = ({ data }) => {
  const [tableView, setTableView] = useState(false);
  const [graphData, setGraphData] = useState([]);

  useEffect(() => {
    const aggregated = {};

    data.forEach(row => {
      if (!(row.Date instanceof Date) || isNaN(row.Date)) return;

      const dateStr = row.Date.toISOString().split("T")[0];
      if (!aggregated[dateStr]) aggregated[dateStr] = { date: dateStr, Views: 0, Clicks: 0, Transactions: 0 };
      aggregated[dateStr].Views += row.Views || 0;
      aggregated[dateStr].Clicks += row.Clicks || 0;
      aggregated[dateStr].Transactions += row.Transactions || 0;
    });

    const sorted = Object.values(aggregated).sort((a, b) => new Date(a.date) - new Date(b.date));
    setGraphData(sorted);
  }, [data]);

  return (
    <div className="analytics-graphs">
      <div className="section-header">
        <h3>Time Series Analysis</h3>
        <button className="table-view-btn" onClick={() => setTableView(!tableView)}>
          {tableView ? "Graph View" : "Table View"}
        </button>
      </div>

      {!tableView ? (
        <div className="graphs-container">
          {[
            { key: "Views", color: "#FF6B6B", title: "Views Over Time" },
            { key: "Clicks", color: "#cd4ecbff", title: "Clicks Over Time" },
            { key: "Transactions", color: "#3acc0eff", title: "Transactions Over Time" },
          ].map((metric) => (
            <div key={metric.key} className="graph-card">
              <h4>{metric.title}</h4>
              <ResponsiveContainer width="100%" height={160}>
                <LineChart data={graphData}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" />
                  <YAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey={metric.key} stroke={metric.color} strokeWidth={2} />
                  <Brush
                    dataKey="date"
                    height={10}             
                    stroke="#000000ff"     
                    travellerWidth={8}      
                    gap={2}                 
                    startIndex={Math.max(0, graphData.length - 10)}
                    endIndex={graphData.length - 1}
                    
                  />

                </LineChart>
              </ResponsiveContainer>
            </div>
          ))}
        </div>
      ) : (
        <div className="table-view">
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Views</th>
                <th>Clicks</th>
                <th>Transactions</th>
              </tr>
            </thead>
            <tbody>
              {graphData.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.date}</td>
                  <td>{row.Views}</td>
                  <td>{row.Clicks}</td>
                  <td>{row.Transactions}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default AnalyticsGraphs;
